<div *ngIf="!report?.renderingFailedAt && !report?.renderingFinishedAt && !report?.calculationFailedAt">
  <h4 class="font-weight-bold">
    {{'lang.reporting.generatingReports'|translate}} {{'lang.globals.pleaseWait'|translate}}
  </h4>
  <div class="my-2">
    {{'lang.reporting.generatingReportsInfo'|translate}}
  </div>
</div>
<sb-page-reporting-file *ngIf=" report?.calculationFailedAt|| report?.renderingFailedAt|| report?.renderingFinishedAt"
                        [report]="report" [isInModalContext]="true"></sb-page-reporting-file>
<div class="d-flex justify-content-end">
  <a class="btn btn-primary" (click)="reportingService.routeToGeneratedReports(report)">
    {{'lang.globals.switchTo' |translate}}&nbsp;"{{'lang.reporting.generatedReports'|translate}}"
  </a>
</div>
